import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyManureStorage, getDairyManureStorageAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_DAIRY_MANURE_STORAGE } from "consts";

import { DairyManureStorage } from "models";

export const useGetDairyManureStorage = () => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("dairy", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((manureStorage: DairyManureStorage[]) => injectNames(manureStorage, t, "storageTypes"), [t]);

  return useQuery({
    queryKey: [GET_DAIRY_MANURE_STORAGE, isAdmin],
    queryFn: () => (isAdmin ? getDairyManureStorageAdmin() : getDairyManureStorage()),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
